

(function($) {
    const breakpoint = +document.body.dataset.breakpoint || 768;


    var sticky_banner = $('.reg_bannner');
    var main_header = $('.main-header');

    var section_padding =  60;
    var footer_wrapper =  $('.payment-section').length > 0 ? $('.payment-section') : $('.footer-wrapper');
    var sticky_banner_offsetTop = sticky_banner.offset().top;


    if(sticky_banner.length > 0 && window.innerWidth >= breakpoint && $(window).height() > 750){

        var header_height = main_header.height();
        var form_height = sticky_banner.height();
        var form_left = sticky_banner.offset().left;
        sticky_banner.css('width',sticky_banner.outerWidth() - 1);

       var formTop = sticky_banner.offset().top;

       $(window).scroll(function(){
        setFixedForm ();
           
       });

       let form_w = sticky_banner.outerWidth() - 1;

       $(window).resize(function(){
        
        sticky_banner.css({
            'position':'relative' , 
            'top':'auto' , 
            'bottom' : 'auto' , 
            'left':'auto' , 
            'z-index':'1',
            'max-width':'100%'});
        
            header_height = main_header.height();
            form_height = sticky_banner.height();
            form_left = sticky_banner.offset().left;

            
            
            sticky_banner.css('width',form_w );
            formTop = sticky_banner.offset().top;

            if(window.innerWidth >= breakpoint){ 
                $(document).scroll(function(){
                    setFixedForm ();
                       
                   });
            }
      });
    
      
   } 

   function setFixedForm (){

    let form_width = sticky_banner.outerWidth() ;

    var offsetTop = $(window).scrollTop() + main_header.height() ;

    if( sticky_banner_offsetTop < offsetTop ){
        
        if( footer_wrapper.offset().top < form_height + offsetTop + section_padding ){
            sticky_banner.css({
                'position':'absolute',
                'top':'auto',
                'bottom': '0',
                'left':'15px',
                'width' : form_width,
                'z-index':'8'});

         }else{
        sticky_banner.css({
            'position':'fixed',
            'top':main_header.height() + 10 ,
            'bottom':'auto',
            'width' : form_width,
            'left':form_left,
            'z-index':'8'});
         }

        }else{
            sticky_banner.css({
                'position':'relative' , 
                'top':'auto' , 
                'bottom' : 'auto' , 
                'left':'auto' , 
                'width' : '100%',
                'z-index':'1'
        });
        }

}


})(window.jQuery);